import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionClick, RowClick } from '../../../models/data-table.interface';
import { CreatedBy, ITemplate } from '../../../models/template.model';
import { environment } from '../../../../environments/environment';

@Component({
    standalone: false,
    selector: 'cva-template-card',
    templateUrl: './template-card.component.html',
    styleUrl: './template-card.component.scss',
    
})
export class TemplateCardComponent {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  @Input() template!: any;
  @Input() defaultTemplate!: boolean;
  @Output() rowClick: EventEmitter<RowClick<ITemplate>> = new EventEmitter<RowClick<ITemplate>>();
  @Output() actionClick: EventEmitter<ActionClick<ITemplate>> = new EventEmitter<ActionClick<ITemplate>>();
  CREATED_BY = CreatedBy;
  cvaUI_url: string = environment.cvaUI_url;

  onRowClicked(): void {
    this.rowClick.emit(this.template);
  }

  onAction(event: MouseEvent, action: 'edit' | 'delete' | 'set-default' | 'fav') {
    event.stopPropagation();
    this.actionClick.emit({ rowData: this.template, action });
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }

}
